module.exports = __webpack_public_path__ + "media/images/ibu__logo__primary-c57b9201e739cc52d3a739738ad30cbd.svg";